import { useContext } from 'react';
import { AccommodationsContext } from '.';

export const useAccommodationsContext = () => {
  const context = useContext(AccommodationsContext);
  if (context === undefined) {
    throw new Error('AccommodationsContext must be used within its context');
  }
  return context;
};
